import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Organization } from '../services/organizationApi'

interface OrgState {
  activeOrg: Organization | null
  orgs: Organization[]
}

interface OrgActions {
  setActiveOrg: (org: Organization) => void
  setOrgs: (orgs: Organization[]) => void
  clearOrg: () => void
}

type OrgStore = OrgState & OrgActions

export const useOrgStore = create<OrgStore>()(
  persist(
    (set) => ({
      activeOrg: null,
      orgs: [],

      setActiveOrg: (org) => set({ activeOrg: org }),
      setOrgs: (orgs) => set({ orgs }),
      clearOrg: () => set({ activeOrg: null }),
    }),
    {
      name: 'ignis_active_org_id',
      // Only persist the active org ID — full org object is re-fetched on load
      partialize: (state) => ({ activeOrg: state.activeOrg }),
    }
  )
)
